module.exports = __webpack_public_path__ + "static/media/Mastercard.7d2748c7.svg";